const Icon = ({ Comp, size = 5, className }) => {
  return (
    <Comp className={className} style={{ width: `${size * 4}px`, height: `${size * 4}px`, display: 'inline-block' }} />
  )
}

export default Icon